import React from "react";
import cx from "classnames";
import { Icon } from "@qgiv/core-react";
import { Divider } from "@qgiv/core-donor";

/**
 * @param {object} props
 * @param {string} props.calculatedImpact
 * @param {string} props.formattedHeading
 * @param {string} props.formattedMatch
 * @param {string} props.formattedSubtotal
 * @param {boolean} props.hasSelectedAmount
 * @param {boolean} props.isMediumScreen
 * @returns {React.ReactElement}
 */
const MatchingCampaignsContent = ({
    calculatedImpact,
    formattedHeading,
    formattedMatch,
    formattedSubtotal,
    hasSelectedAmount,
    isMediumScreen,
}) => (
    <div className="qg-vendor-matching-campaign-content -text--center">
        <div className="matching-campaigns__content--icon-container">
            <Icon
                ariaHidden
                className={cx(
                    "matching-campaigns__content--icon",
                    hasSelectedAmount && "-color--theme-primary",
                )}
                glyph="gifts-duotone"
                type="FontAwesome"
            />
        </div>
        <h2 className="matching-campaigns__content--header -margin-top--10">
            {formattedHeading}
        </h2>
        {hasSelectedAmount && (
            <div
                className={cx(
                    "matching-campaigns__multiplier-container",
                    isMediumScreen &&
                        "matching-campaigns__multiplier-container--mobile-padding",
                )}
            >
                <span className="-padding--10">
                    <p className="matching-campaigns__multiplier-container--amount">
                        {formattedSubtotal}
                    </p>
                    <strong className="matching-campaigns__multiplier-container--amount-type -type--small">
                        GIFT
                    </strong>
                </span>
                <Divider dashed />
                <strong className="matching-campaigns__multiplier-container--multiplier -color--theme-primary -type--3xlarge -margin-left--5 -margin-right--5">
                    {formattedMatch}
                </strong>
                <Divider dashed />
                <span className="-padding--10">
                    <p className="matching-campaigns__multiplier-container--amount">
                        {calculatedImpact}
                    </p>
                    <strong className="matching-campaigns__multiplier-container--amount-type -type--small">
                        IMPACT
                    </strong>
                </span>
            </div>
        )}
    </div>
);

export default MatchingCampaignsContent;
